var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Radar',{attrs:{"chart-options":_vm.chartOptions,"chart-data":_vm.chartData,"chart-id":"competencies-radar","dataset-id-key":"label","width":400,"height":400}})
}
var staticRenderFns = []

export { render, staticRenderFns }